import { render, staticRenderFns } from "./ChatToggle.vue?vue&type=template&id=153ee0b2&scoped=true"
import script from "./ChatToggle.vue?vue&type=script&lang=js"
export * from "./ChatToggle.vue?vue&type=script&lang=js"
import style0 from "./ChatToggle.vue?vue&type=style&index=0&id=153ee0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ee0b2",
  null
  
)

export default component.exports